import styled from "@emotion/native";
import { Platform } from "react-native";
import Image from "react-native-scalable-image";
import { useSafeAreaFrame } from "react-native-safe-area-context";

export const Container = styled.View(
    {
        flex: 1,
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);

export const Background = styled.Image({
    position: "absolute",
    width: "100%",
    height: "100%",
    resizeMode: "cover",
});

export const Scroll = styled.ScrollView({
    overflow: Platform.OS === "android" ? "scroll" : "visible",
});

export const Header = styled.View({
    paddingHorizontal: 12,
    marginTop: 28,
    justifyContent: "center",
    alignItems: "center",
    height: 250,
    overflow: "hidden",
});

export const Body = styled.View({
    alignSelf: "center",
    paddingTop: 12,
    paddingBottom: 30,
    paddingHorizontal: 65,
});

export const Hero = styled.Image(
    {
        position: "absolute",
        opacity: 0.75,
        width: "100%",
        height: 250,
        resizeMode: "cover",
    },
    () => {
        const frame = useSafeAreaFrame();
        let style = {
            width: frame.width,
            marginTop: 0,
        };

        return style;
    },
);

export const MediaImage = styled(Image)(
    {
        resizeMode: "contain",
    },
    ({ width }: any) => {
        return {
            width,
        };
    },
);
